"use strict";
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.MedicalHistoryService = void 0;
const tslib_1 = require("tslib");
const common_1 = require("@nestjs/common");
const typeorm_1 = require("@nestjs/typeorm");
const typeorm_2 = require("typeorm");
const medical_doc_entity_1 = require("./medical-doc.entity");
const medical_upload_link_entity_1 = require("./medical-upload-link.entity");
const crypto_1 = require("crypto");
let MedicalHistoryService = class MedicalHistoryService {
    constructor(docRepo, uploadLinkRepo) {
        this.docRepo = docRepo;
        this.uploadLinkRepo = uploadLinkRepo;
    }
    findAll(customerId) {
        return this.docRepo.find({
            where: { customer: { id: customerId }, isActive: true },
            relations: ['customer', 'uploadedBy'],
            order: { createdAt: 'DESC' },
        });
    }
    async findById(id) {
        const doc = await this.docRepo.findOne({
            where: { id },
            relations: ['customer', 'uploadedBy'],
        });
        if (!doc)
            throw new common_1.NotFoundException(`MedicalDoc #${id} not found`);
        return doc;
    }
    create(dto) {
        const doc = this.docRepo.create({
            customer: { id: dto.customerId },
            docType: dto.docType,
            fileName: dto.fileName,
            fileUrl: dto.fileUrl,
            fileExtension: dto.fileExtension,
            notes: dto.notes,
            uploadedBy: { id: dto.uploadedById },
            isActive: true,
        });
        return this.docRepo.save(doc);
    }
    async setValidity(id, validUntil) {
        const doc = await this.findById(id);
        doc.validUntil = validUntil;
        return this.docRepo.save(doc);
    }
    async deactivate(id) {
        const doc = await this.findById(id);
        doc.isActive = false;
        return this.docRepo.save(doc);
    }
    async generateUploadLink(customerId, requestedDocType, notes) {
        const existing = await this.uploadLinkRepo.findOne({ where: { customerId } });
        if (existing && !existing.uploadComplete && (!existing.expiresAt || existing.expiresAt > new Date())) {
            existing.requestedDocType = requestedDocType;
            existing.notes = notes ?? null;
            return this.uploadLinkRepo.save(existing);
        }
        const token = (0, crypto_1.randomUUID)().replace(/-/g, '');
        const expiresAt = new Date(Date.now() + 7 * 24 * 60 * 60 * 1000);
        const link = this.uploadLinkRepo.create({
            customer: { id: customerId },
            customerId,
            token,
            expiresAt,
            requestedDocType,
            notes: notes ?? null,
            files: [],
            uploadComplete: false,
        });
        return this.uploadLinkRepo.save(link);
    }
    async completeUploadLink(token) {
        const link = await this.uploadLinkRepo.findOne({ where: { token } });
        if (!link)
            throw new common_1.NotFoundException('Upload link not found.');
        if (link.uploadComplete)
            return link;
        const files = link.files ?? [];
        const apiBase = process.env['API_PUBLIC_URL'] ?? 'http://localhost:3000/api';
        for (const file of files) {
            const extension = file.originalName.split('.').pop()?.toLowerCase() ?? '';
            await this.docRepo.save(this.docRepo.create({
                customer: { id: link.customerId },
                uploadedBy: null,
                docType: link.requestedDocType ?? medical_doc_entity_1.DocType.OTHER,
                fileName: file.originalName,
                fileUrl: `${apiBase}${file.url}`,
                fileExtension: extension,
                notes: link.notes ?? null,
                isActive: true,
            }));
        }
        link.uploadComplete = true;
        return this.uploadLinkRepo.save(link);
    }
    checkExpiredPrescriptions(customerId) {
        return this.docRepo.find({
            where: {
                customer: { id: customerId },
                docType: medical_doc_entity_1.DocType.PRESCRIPTION,
                isActive: true,
                validUntil: (0, typeorm_2.LessThan)(new Date()),
            },
            relations: ['customer', 'uploadedBy'],
            order: { validUntil: 'ASC' },
        });
    }
};
exports.MedicalHistoryService = MedicalHistoryService;
exports.MedicalHistoryService = MedicalHistoryService = tslib_1.__decorate([
    (0, common_1.Injectable)(),
    tslib_1.__param(0, (0, typeorm_1.InjectRepository)(medical_doc_entity_1.MedicalDoc)),
    tslib_1.__param(1, (0, typeorm_1.InjectRepository)(medical_upload_link_entity_1.MedicalUploadLink)),
    tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof typeorm_2.Repository !== "undefined" && typeorm_2.Repository) === "function" ? _a : Object, typeof (_b = typeof typeorm_2.Repository !== "undefined" && typeorm_2.Repository) === "function" ? _b : Object])
], MedicalHistoryService);
